import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { formatPrice, debug } from 'utils';
import { BiTrashAlt } from 'react-icons/bi';
export default function OrderItems({
  items = [],
  totalPriceET = 0,
  orderVATAmount = 0,
  totalPriceIT = 0,
  onRemoveItem = null
}) {
  const [openItems, setOpenItems] = useState({});
  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  return (
    <div className="cart-items">
      <table className="table table-sm cart-table">
        <colgroup>
          <col style={{ width: '50%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: onRemoveItem ? '6%' : '10%' }} />
          {onRemoveItem &&
            <col style={{ width: '4%' }} />
          }
        </colgroup>

        <thead>
          <tr>
            <th>Libellé</th>
            <th className="text-end">HT</th>
            <th className="text-end">TVA %</th>
            <th className="text-end">TVA</th>
            <th className="text-end">TTC</th>
            <th></th>
            {onRemoveItem &&
              <th></th>
            }
          </tr>
        </thead>

        {items.map((item, itIndex) => {
          const rows = item.invoiceRows || [];
          return (
            <tbody key={itIndex} className="cart-item-group">
              {rows.map((row, index) => {
                if (row.isTitle) {
                  return (
                    <tr key={index} className='table-light'>
                      <td className="fw-semibold pt-3">
                        {row.label}
                      </td>
                      <td className="text-end fw-bold">
                        {formatPrice(item.itTotalPriceET)} €
                      </td>
                      <td>

                      </td>
                      <td className="text-end fw-bold">
                        {formatPrice(item.itVATAmount)} €
                      </td>
                      <td className="text-end fw-bold">
                        {formatPrice(item.itTotalPriceIT)} €
                      </td>
                      <td className="text-end fw-bold">
                        {item.itProdType !== 'discount' &&
                          <span
                            className="text-primary pointer d-inline-flex align-items-center gap-1"
                            onClick={() => toggleItem(item.itId)}
                          >
                            Détail
                            {openItems[item.itId]
                              ? <FiChevronUp />
                              : <FiChevronDown />}
                          </span>
                        }
                      </td>
                      {onRemoveItem &&
                        <td className='text-end pointer'>
                          {item.itProdType !== 'discount' &&
                            <BiTrashAlt className="text-danger" onClick={() => { onRemoveItem(item) }} />
                          }
                        </td>
                      }
                    </tr>
                  );
                }
                if (!openItems[item.itId]) return null;
                return (
                  <tr key={index}>
                    <td>{row.label}</td>
                    <td className="text-end">
                      {formatPrice(row.total_et || 0)} €
                    </td>
                    <td className="text-end">
                      {row.vatRate ?? row.vat_rate ?? 0}%
                    </td>
                    <td className="text-end">
                      {formatPrice(row.vat_amount || 0)} €
                    </td>
                    <td className="text-end">
                      {formatPrice(row.total_it || 0)} €
                    </td>
                    <td></td>
                    {onRemoveItem &&
                      <td></td>
                    }
                  </tr>
                );
              })}
            </tbody>
          );
        })}
        <tfoot>
          <tr>
            <td className="fw-bold bg-green">Total</td>
            <td className="text-end fw-bold bg-green">
              {formatPrice(totalPriceET)}
            </td>
            <td className="text-end fw-bold bg-green"></td>
            <td className="text-end fw-bold bg-green">
              {formatPrice(orderVATAmount)}
            </td>
            <td className="text-end fw-bold bg-green">
              {formatPrice(totalPriceIT)}
            </td>
            <td className="text-end fw-bold bg-green"></td>
            {onRemoveItem &&
              <td className="text-end fw-bold bg-green"></td>
            }

          </tr>
        </tfoot>
      </table>

    </div>
  );
}


